type ConfigType = {
  API_URL: string
  URL: string
  RECAPTCHA_KEY: string
  CANONICAL_URL: string
}

export const Config: ConfigType = {
  API_URL: process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000/",
  URL: process.env.NEXT_PUBLIC_IMAGE_URL || "http://localhost:3000/",
  RECAPTCHA_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || "",
  CANONICAL_URL: process.env.NEXT_PUBLIC_CANONICAL_URL || "http://localhost:3000",
}